<template>
  <div  
    id="provider-directory"
    class="provider-directory">
    <!--<div v-if="$store.status.ready">-->
      <router-view v-slot="{ Component }" :key="$route.fullPath">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    <!--</div>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    userFilters () {
      return this.$store.params.filters
    }
  },
  watch: {
    userFilters: {
      handler () {
        this.$dispatch.getData(true)
     },
     deep: true
    }
  },
  mounted () {
    if (this.$dispatch.checkForQuery(this.$route.query)) {
      
      this.$commit.status('ready', true)
    }

    if (this.$route.name == 'Provider') {
      this.$commit.status ('dir_entry', false)
    }
  }
}
</script>
